import { T_OFFLINE_OVERLAY_PAGE_CONSTANTS } from './TYPES'

const EN_OFFLINE_OVERLAY_PAGE_CONSTANTS: T_OFFLINE_OVERLAY_PAGE_CONSTANTS = {
  OFFLINE_TITLE: 'No Internet Connection.',
  OFFLINE_DESCRIPTION:
    'Please check your internet connection to continue using the app.'
}

export default EN_OFFLINE_OVERLAY_PAGE_CONSTANTS
